export default __webpack_public_path__ + "static/media/K.ff262de2.svg";